<template>
  <section class="bg-white rounded-xl shadow-lg p-8 sm:p-8 w-auto min-w-[55rem]">
    <div v-if="!isRenderLoading" class="grid grid-cols-1 sm:grid-cols-2 gap-6">
      <!-- DYNAMIC COLUMNS -->
      <div v-for="module in itemMenuCategory" :key="module.id" class="space-y-3">
        <!-- MODULE NAME -->
        <h2 class="text-orange-600 font-semibold uppercase tracking-wide text-sm">
          {{ module.name }}
        </h2>

        <!-- MODULE SECTIONS -->
        <ul class="mt-2 space-y-3 text-gray-700 text-sm">
          <li
            v-for="section in module.moduleSections"
            :key="section.id"
            class="flex items-center gap-2"
          >
            <router-link
              class="flex gap-2 items-center"
              :to="`/portal/${module.code}/${section.code}/${encryptFile(section.id)}`"
              @click="$emit('menuClick', false)"
            >
              <!-- ICON -->
              <template v-if="section.icon && section.icon.filename">
                <component :is="section.icon.filename" height="19" width="19" />
              </template>

              <!-- SECTION NAME -->
              <span> {{ section.name }} </span>
              <span
                v-if="unreadMap[section.id]"
                class="ml-1 px-2 py-0.5 text-xs font-medium text-white bg-red-500 rounded-full"
              >
                {{ unreadMap[section.id] }}
              </span>
              <span v-if="section.page_layout === 'blank'">
                <span
                  class="px-2 py-0.5 text-xs font-medium text-blue-600 bg-blue-100 rounded-md border border-blue-200"
                >
                  Soon
                </span>
              </span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>

    <!-- LOADING -->
    <div v-else class="flex justify-center items-center">
      <LoadingGlobal />
    </div>
  </section>
</template>

<script>
import MegaPhoneIcon from '@/components/svgs/icons/megaphone-icon.vue';
import BellIcon from '@/components/svgs/icons/bell-icon.vue';
import BuildingIcon from '@/components/svgs/icons/building-icon.vue';
import HeartIcon from '@/components/svgs/icons/heart-icon.vue';
import HierarchyIcon from '@/components/svgs/icons/hierarchy-icon.vue';
import CalendarIcon from '@/components/svgs/icons/calendar-icon.vue';
import CalendarCloseIcon from '@/components/svgs/icons/calendar-close-icon.vue';
import PartyIcon from '@/components/svgs/icons/party-icon.vue';
import encryptHandler from '@/utils/encrypt';
import countBadgeHandler from '@/utils/reusables/countBadgeNotif';
import { inject, onMounted, ref, computed } from 'vue';

export default {
  components: {
    'megaphone-icon': MegaPhoneIcon,
    'bell-icon': BellIcon,
    'building-icon': BuildingIcon,
    'heart-icon': HeartIcon,
    'hierarchy-icon': HierarchyIcon,
    'calendar-icon': CalendarIcon,
    'calendar-close-icon': CalendarCloseIcon,
    'party-icon': PartyIcon
  },

  setup() {
    const { encryptFile } = encryptHandler();
    const { sectionCountUnreadHandler, sectionCountBadgeUnread } = countBadgeHandler();
    const axios = inject('$axios');

    const isRenderLoading = ref(true);
    const itemMenuCategory = ref([]);

    onMounted(async () => {
      try {
        const { data } = await axios.get('/api/modules', {
          params: { includeSectionPosts: false }
        });

        if (data?.data) {
          itemMenuCategory.value = data.data;
          await sectionCountUnreadHandler();

          console.log('Test Data', sectionCountBadgeUnread.value);
        }
      } catch (error) {
        console.log('render error:', error.response);
      } finally {
        isRenderLoading.value = false;
      }
    });
    const unreadMap = computed(() => {
      const map = {};

      sectionCountBadgeUnread.value.forEach((item) => {
        map[item.section_id] = item.unreadCount;
      });

      return map;
    });

    return {
      itemMenuCategory,
      encryptFile,
      isRenderLoading,
      sectionCountUnreadHandler,
      sectionCountBadgeUnread,
      unreadMap
    };
  }
};
</script>
